import { Component, Input, OnInit } from '@angular/core'
import { Tab, TabsComponent } from '@ui/Components/Tabs/Tabs.Component'
import Order from '@client/Order'
import { OrderItemsComponent } from '@client/Components/Orders/Order/OrderItems.Component'
import { OrderPaymentPlansComponent } from '@client/Components/Orders/Order/OrderPaymentPlans.Component'
import { OrderPaymentsComponent } from '@client/Components/Orders/Order/OrderPayments.Component'

@Component({
	selector: 'order-tab-view',
	templateUrl: './OrderTabView.Component.html',
	imports: [TabsComponent],
})
export class OrderTabViewComponent implements OnInit {
	@Input() private readonly order: Order

	protected tabs: Tab[] = []

	public ngOnInit() {
		this.tabs = [
			{
				label: 'Guests',
				component: {
					instance: OrderItemsComponent,
					additionalData: {
						order: this.order,
					},
				},
			},
			{
				label: 'Payment Plans',
				component: {
					instance: OrderPaymentPlansComponent,
					additionalData: {
						order: this.order,
					},
				},
			},
			{
				label: 'Payments',
				component: {
					instance: OrderPaymentsComponent,
					additionalData: {
						order: this.order,
					},
				},
			},
		]
	}
}
